function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ErrorTruck_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.449 205.549l18.358-29.134-18.367 32.308-.01 3.319a71.173 71.173 0 01-3.889-.15l1.497-42.644-.02-.33.034-.063.143-4.03L0 132.895l19.215 28.913.057.853 1.132-32.219L3.902 97.406l16.63 27.375.774-66.782.004-.223.002.22.377 52.652 15.768-21.067-15.782 25.602-.073 28.838 14.63-27.852-14.638 32.092-.04 16.036 21.252-38.78-21.27 44.374-.087 35.658z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.128 82.579h-5.161v36.644h5.161V82.579z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.15 4.594l-1.942 4.782 190.99 77.52 1.941-4.782-190.99-77.52z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427.24 210.399c-7.994 13.356-427.662 12.235-427.026 0 7.994-13.355 427.662-12.234 427.026 0z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M374.61 156.384h-44.902v17.548h44.902v-17.548z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370.481 171.867H149.067v19.612h221.414v-19.612z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.095 181.673h-53.16v-66.837h39.741l13.419 33.71v33.127z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M311.902 118.965h-22.71v22.709h22.71v-22.709zm17.031 22.968h-14.451v-22.709h6.194l8.257 22.709z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.386 154.577h-5.161v9.806h5.161v-9.806zm23.483-20.902h.258a4.899 4.899 0 014.903 4.903 4.902 4.902 0 01-4.903 4.903h-.258v-9.806zm-191.996 38.192h.258a4.899 4.899 0 014.903 4.903 4.902 4.902 0 01-4.903 4.903h-.258v-9.806z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M354.739 171.793c7.865 0 14.94 3.81 19.848 9.88h10.087l-9.806-27.316-45.677-9.008 1.291 36.324h4.409c4.909-6.07 11.983-9.88 19.848-9.88z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.255 210.576c12.4 0 22.451-10.052 22.451-22.451 0-12.399-10.051-22.451-22.451-22.451-12.399 0-22.451 10.052-22.451 22.451 0 12.399 10.052 22.451 22.451 22.451z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.255 199.941c6.526 0 11.817-5.29 11.817-11.816 0-6.526-5.291-11.816-11.817-11.816s-11.816 5.29-11.816 11.816c0 6.526 5.29 11.816 11.816 11.816z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.421 210.318c10.832 0 19.613-8.781 19.613-19.613 0-10.831-8.781-19.612-19.613-19.612-10.831 0-19.612 8.781-19.612 19.612 0 10.832 8.781 19.613 19.612 19.613z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.421 201.027c5.701 0 10.323-4.621 10.323-10.322 0-5.701-4.622-10.322-10.323-10.322-5.701 0-10.322 4.621-10.322 10.322 0 5.701 4.621 10.322 10.322 10.322z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.483 105.546h-10.839v78.192h10.839v-78.192z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.483 169.544H126.615v4.645h155.868v-4.645zm-69.296-29.198L43.202 186.592l1.22 4.482 169.984-46.246-1.219-4.482z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.584 145.981l-2.912 2.139 17.882 24.333 2.912-2.139-17.882-24.333zm120.382-3.017h-5.161v2.065h5.161v-2.065z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.548 158.448h-67.612a.518.518 0 01-.51-.442.513.513 0 01.363-.569l66.063-19.612a.517.517 0 01.662.454l1.548 19.612a.513.513 0 01-.514.557zm-64.06-1.032h63.501l-1.454-18.421-62.047 18.421zM93.46 135.739h-.005l-14.816-.14a.505.505 0 01-.382-.174.513.513 0 01-.126-.4l7.698-67.172a.516.516 0 01.513-.457h.002a.517.517 0 01.511.461l7.118 67.312a.513.513 0 01-.303.525.508.508 0 01-.21.045zm-14.238-1.166l13.664.128-6.565-62.077-7.1 61.949zm299.02 29.355l-.241.091a4.902 4.902 0 11-3.469-9.172l.241-.091 3.469 9.172zm-313.941 3.01l-14.397 4.029.64 2.286 14.397-4.03-.64-2.285z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.554 138.373l-2.779 1.517-112.891 31.599-1.676-2.082a24.793 24.793 0 01-5.362-12.421c-.426-3.403-.114-6.989 2.26-9.172l-4.312-34.772 62.435-17.56 29.613 12.742s11.343-3.389 19.69 2.591c2.642 1.895 4.985 4.729 6.57 8.91l1.365 3.943 5.087 14.705z",
  fill: "#FFC72C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.599 159.218c7.994 0 14.475-6.481 14.475-14.476 0-7.995-6.481-14.476-14.475-14.476-7.995 0-14.476 6.481-14.476 14.476 0 7.995 6.481 14.476 14.476 14.476z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.599 152.361a7.619 7.619 0 100-15.238 7.619 7.619 0 000 15.238z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.813 178.47c7.995 0 14.476-6.481 14.476-14.475 0-7.995-6.481-14.476-14.476-14.476S60.337 156 60.337 163.995c0 7.994 6.481 14.475 14.476 14.475z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.813 171.614a7.619 7.619 0 100-15.238 7.619 7.619 0 000 15.238z",
  fill: "#E4E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.604 108.625l-44.79 12.537-3.775-13.483 28.566-7.995 19.999 8.941zm-54.05.589l-17.824 4.99 3.774 13.483 17.824-4.99-3.773-13.483z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.913 130.578l-2.286.639 1.216 4.342 2.285-.639-1.215-4.342zm36.619-14.439l-.64-2.285-4.342 1.215.64 2.285 4.342-1.215z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.758 106.074l.251-.071a4.962 4.962 0 016.113 3.44 4.956 4.956 0 01-3.439 6.113l-.251.07-2.674-9.552zm46.709 17.594a7.669 7.669 0 01-9.372-3.09 7.666 7.666 0 011.437-9.763c2.642 1.895 4.985 4.729 6.57 8.911l1.365 3.942zM88.681 4.645H83.52v75.353h5.16V4.645z",
  fill: "#2A2A28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.1 14.451a7.226 7.226 0 100-14.45 7.226 7.226 0 000 14.45zm190.447 76.386a7.226 7.226 0 100-14.451 7.226 7.226 0 000 14.451z",
  fill: "#2A2A28"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ErrorTruck_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h427.241v220H0z"
})));

function SvgErrorTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428 220"
  }, props), _ref, _ref2);
}

export default SvgErrorTruck;